import { render, staticRenderFns } from "./ConvRedirect.vue?vue&type=template&id=4d82f8b7&scoped=true"
import script from "./ConvRedirect.vue?vue&type=script&lang=js"
export * from "./ConvRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82f8b7",
  null
  
)

export default component.exports